module.exports = __webpack_public_path__ + "static/media/outside-test.4956c0be.png";